import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import AddIcon from '@material-ui/icons/Add';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MenuItem from '@material-ui/core/MenuItem';
import { COLORS } from '../../styles/colors';
import ButtonContent from '../ButtonContent';
import { ConfirmJsMessage, tzStrings, parQMetaData } from '../../helpers.js';
import TimePick from "./OnlyTimePicker";
import StartCalendar from "./StartCalendar";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField'
import { AlertJsMessage } from './../../helpers.js';
import ScheduleMessageListing from './../assignments/ScheduleMessageListing';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import PARQListing from './../assignments/PARQListing';

import moment from 'moment';

const styles = theme => ({
    root: {
        "& .MuiInputBase-input": {
          height: "160px !important",
        },
      },
    textarea: {
      height: "190px !important"
    },
    hours: {
        height: "50px !important"
    },
    disabledInput: {
        "& .MuiInputBase-input.Mui-disabled": {
            background:  COLORS.grey,
            opacity: '0.6'
         }
    },
    smallRadioButton: {
        "& .MuiRadio-colorSecondary.Mui-checked": {
           color:  COLORS.orange
        }
    }
});

const ParQ = withStyles(styles)(props => {

   const {
		clientEmail,
        deletePARQ,
        fetchPARQS,
        savePARQ,
        user,
        isEdit,
        isMobile,
        item,
        classes
	} = props;

	const [data, setData] = useState({
        trainerName: '',
        businessName: '',
        address: ''
    });
    const [survey, setSurvey] = useState(parQMetaData);

    const [isOpenViewAction, setOpenViewAction] = useState(false);
    
	useEffect(() => {
        if (isEdit && item) {
            const { trainerName, businessName, address  } = item.survey;
            setData({
                trainerName,
                businessName,
                address
            })
            if (item.survey) {
                const survey = item.survey;
                delete survey.trainerName;
                delete survey.businessName;
                delete survey.address;
                setSurvey(survey)
            }
        } else {
            setData({
                ...data,
            })
        }
	}, [clientEmail])


    
    const submitData = () => {
        if(data.trainerName === '' || data.businessName === '' || data.address === '') {
            AlertJsMessage('Fields are required.');
            return;
        }
        const updateData = {
            ...survey,
            ...data,
            bottomSection1: "WAIVER",
            bottomSection2: "I release and discharge #TRAINER_NAME and #BUSINESS_NAME and their staff of any claims, injuries, losses, or liabilities suffered or incurred as a result of my participation in any physical activity held at #ADDRESS."
        }
        
        savePARQ({
            survey: updateData,
            clientEmail: clientEmail,
            _id: item ? item._id : undefined
        })
        .then((res) => {
            if (item) {
                if (res.parqDetails && item._id) {
                    props.parentData(res.parqDetails)
                }
            }
        })
    }

    

    const handleChange = (evt) => {
        let { value, name } = evt.target
        setData({
            ...data,
            [name]: value
        })
    }

   
    const isDisbaledSave = () => {
        return data.trainerName === '' 
                || data.address === ''
                || data.businessName === ''
    }

    const viewHistory = () => {
        setOpenViewAction(!isOpenViewAction)
    }

    const renderSubHeadings = (question) => {
        if(!question.subHeading) {
            return null;
        }
        return question.subHeading.map((subHeading) => {
            return (<li style={{
                marginLeft: 50,
                listStyle: 'disc'
            }}>{subHeading}</li>)
        })
    }

    const renderOptions = (question) => {
        if(!question.options) {
            return null;
        }
        return question.options.map((option) => {
            return (<FormControlLabel value={option} className={classes.smallRadioButton} control={<Radio checked={question.answerOption === option} disabled />} label={option} />)
        })
    }

    const renderYes = (question) => {
        if(!question.isYesReq) {
            return null;
        }
        return (
            item.isCompleted ? <div style={{
                color: COLORS.red,
                fontWeight: 'bold',
                width: isMobile ? '320px' : '700px'
            }}>{question.answerYes}</div> :
            <TextField
                InputLabelProps={{
                    shrink: true
                }}
                label=""
                disabled
                className={classes.disabledInput}
                value={question.answerYes}
                rows={5}
                name="message"
                onChange={() => {}}
                variant="outlined"
            />
        )
        
    }


    
    return (
        <Fragment>
                <div
					style={{
					    width: isMobile ? '100%' : '800px'
                   }}
				>
                    {!isEdit &&
                        (<div style={{
                                    textAlign: 'right'
                                }}>
                            <Button
                                color="primary"
                                onClick={() => viewHistory()}
                                style={{
                                    color: COLORS.orange,
                                    fontSize: '10px'
                                }}
                            >
                                <ButtonContent text={ !isOpenViewAction ? "View History" : "Back" }  />
                            </Button>
                        </div>) 
                   }
                   { isOpenViewAction && (
                        <PARQListing 
                            fetchPARQS = { fetchPARQS} 
                            clientEmail = { clientEmail}
                            deletePARQ = { deletePARQ }
                            savePARQ = { savePARQ}
                            isMobile = {isMobile}
                        >
                        </PARQListing>) 
                    } 
                     { !isOpenViewAction && (
                        <div style={{marginTop: '5px'}}>
                        <div style={{
                                        display: 'flow-root',
                                        padding: 20,
                                        paddingLeft: 0,
                                        width: '100%',
                                        }}>
                                    <div style={{
                                        display: 'initial',
                                        float: 'left',
                                        width: isMobile ? '100%' : '700px'
                                    }}>
                                        {survey.topHeading.map((heading, index) => {
                                            return (
                                                <div style={{marginBottom: 10}}>{heading}</div>
                                            )
                                        })}
                                        {survey.questions.map((question, index) => {
                                            return (
                                                <div style={{marginBottom: 10}}>
                                                    {index+1}) {question.heading}
                                                    <ul>{renderSubHeadings(question)}</ul>
                                                        <RadioGroup
                                                            aria-labelledby="demo-radio-buttons-group-label"
                                                            name="radio-buttons-group"
                                                            row
                                                            style={{marginLeft: 15}}
                                                        >
                                                        {renderOptions(question)}
                                                        {renderYes(question)}
                                                        </RadioGroup>
                                                </div>
                                            )
                                        })}
                                        <div style={{
                                            textAlign: 'center',
                                            marginBottom: 20
                                        }}>WAIVER</div>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            flexFlow: 'row wrap',
                                        }}>                                
                                        <div style={{
                                            marginBottom: 10,
                                            display: 'flex',
                                            flexDirection: 'row',
                                            flexFlow: 'row wrap',
                                            alignItems: 'center'
                                        }}>
                                                    <Fragment>
                                                    <div className="Child1" style={{ marginTop : isMobile && 20 }}>I release and discharge </div>
                                                    <div className="Child1" style={{ marginTop : isMobile && 20 }}>
                                                            <TextField
                                                                label="Name"
                                                                value={data.trainerName}
                                                                name="trainerName"
                                                                margin="normal"
                                                                variant="outlined"
                                                                onChange={handleChange}
                                                                style = {{
                                                                    width: 200,
                                                                    marginLeft: 5,
                                                                    marginTop: -10,
                                                                    marginRight: 5
                                                                }}
                                                            >
                                                            </TextField>
                                                    </div>
                                                    <div className="Child1">  and </div>  
                                                    <div className="Child1" style={{ marginTop : isMobile && 20}}>
                                                    <TextField
                                                                label="Name of Business"
                                                                value={data.businessName}
                                                                name="businessName"
                                                                margin="normal"
                                                                variant="outlined"
                                                                onChange={handleChange}
                                                                style = {{
                                                                    width: 200,
                                                                    marginLeft: 5,
                                                                    marginTop: -10,
                                                                    marginRight: 5
                                                                }}
                                                            >
                                                            </TextField> 
                                                        </div>
                                                        <div className="Child1" style={{
                                                            lineHeight: '3'
                                                        }}>
                                                            and their staff of any claims, injuries, losses, or liabilities suffered or incurred as a result of my participation in any physical activity held at 
                                                            <TextField
                                                                label="(address of business or name of business)"
                                                                value={data.address}
                                                                name="address"
                                                                margin="normal"
                                                                variant="outlined"
                                                                onChange={handleChange}
                                                                style = {{
                                                                    width: isMobile ? 300 : 400,
                                                                    marginLeft: 5,
                                                                    marginTop: -5,
                                                                    marginRight: 5
                                                                }}
                                                            />
                                                            .
                                                        </div>
                                                    </Fragment>
                                        </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                { !item.isCompleted &&
                                    <div style={{ marginTop: '5px'}}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => submitData()}
                                            disabled={isDisbaledSave()}
                                        >
                                            <ButtonContent
                                                text="ASSIGN NOW"
                                                icon="chevron-right" />
                                        </Button>
                                    </div>
                                }
                            </div>
                    )}
                </div>
        </Fragment>
    );
});

export default ParQ;



// WEBPACK FOOTER //
// ./src/components/assignments/ParQ.js